import { composeIO } from 'react-compose-io'
import { regraNotaFiscalIO } from './RegraNotaFiscal.IO'
import { RegraNotaFiscalView } from './RegraNotaFiscal.View'

export const RegraNotaFiscal = composeIO(RegraNotaFiscalView, regraNotaFiscalIO)
